import React, { useEffect, useRef } from "react";

import Slider from "react-slick";

const ProjectDetailsModal = ({ darkTheme, projectDetails }) => {
  const sliderRef = useRef();

  // Check if we have multiple images (need slider) or just one (no slider needed)
  const hasMultipleImages = projectDetails?.sliderImages?.length > 1;

  var settings = {
    dots: hasMultipleImages, // Only show dots if multiple images
    arrows: false,
    infinite: hasMultipleImages, // Only loop if multiple images
    adaptiveHeight: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };

  useEffect(() => {
    if (sliderRef.current && hasMultipleImages) {
      sliderRef.current.slickGoTo(0);
    }
  }, [projectDetails, hasMultipleImages]);

  return (
    <>
      <div
        className="modal fade bg-dark-1"
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div
            className={
              "modal-content " + (darkTheme ? "bg-dark-2 text-light" : "")
            }
          >
            <div className="modal-body">
              <button
                type="button"
                className={"btn-close " + (darkTheme ? "btn-close-white" : "")}
                data-bs-dismiss="modal"
                aria-label="Close"
              />
              <div
                className={
                  "container ajax-container " +
                  (darkTheme ? "bg-dark-2 text-light" : "")
                }
              >
                <h2
                  className={
                    "text-6 font-weight-600 text-center mb-4" +
                    (darkTheme ? " text-white" : "")
                  }
                >
                  {projectDetails?.title}
                </h2>
                <div className="row g-4">
                  <div className="col-md-7">
                    {hasMultipleImages ? (
                      // Use slider for multiple images
                      <Slider {...settings} ref={sliderRef}>
                        {projectDetails?.sliderImages?.map((image, index) => (
                          <div className="item" key={index}>
                            <img className="img-fluid" alt="" src={image} />
                          </div>
                        ))}
                      </Slider>
                    ) : (
                      // Show single image without slider
                      <div className="item">
                        {projectDetails?.sliderImages?.[0] && (
                          <img
                            className="img-fluid rounded"
                            alt={projectDetails?.title}
                            src={projectDetails?.sliderImages[0]}
                          />
                        )}
                      </div>
                    )}
                  </div>
                  <div className="col-md-5">
                    <h4
                      className={
                        "text-4 font-weight-600" +
                        (darkTheme ? " text-white" : "")
                      }
                    >
                      Project Info:
                    </h4>
                    <p>{projectDetails?.projectInfo}</p>
                    <h4
                      className={
                        "text-4 font-weight-600 mt-4" +
                        (darkTheme ? " text-white" : "")
                      }
                    >
                      Project Details:
                    </h4>
                    <ul
                      className={
                        "list-style-2 " + (darkTheme ? "list-style-light" : "")
                      }
                    >
                      {projectDetails?.repos && (
                        <li>
                          <span
                            className={
                              "text-dark font-weight-600 me-2" +
                              (darkTheme ? " text-white" : "")
                            }
                          >
                            Repositories:
                          </span>
                          <div>
                            {projectDetails.repos.frontend && (
                              <div>
                                <a
                                  href={projectDetails.repos.frontend.link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-primary"
                                >
                                  {projectDetails.repos.frontend.name}
                                </a>
                              </div>
                            )}
                            {projectDetails.repos.backend && (
                              <div className="mt-1">
                                <a
                                  href={projectDetails.repos.backend.link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-primary"
                                >
                                  {projectDetails.repos.backend.name}
                                </a>
                              </div>
                            )}
                          </div>
                        </li>
                      )}
                      <li>
                        <span
                          className={
                            "text-dark font-weight-600 me-2" +
                            (darkTheme ? " text-white" : "")
                          }
                        >
                          Technologies:
                        </span>
                        {projectDetails?.technologies}
                      </li>
                      <li>
                        <span
                          className={
                            "text-dark font-weight-600 me-2" +
                            (darkTheme ? " text-white" : "")
                          }
                        >
                          Industry:
                        </span>
                        {projectDetails?.industry}
                      </li>

                      <li>
                        <span
                          className={
                            "text-dark font-weight-600 me-2" +
                            (darkTheme ? " text-white" : "")
                          }
                        >
                          URL:
                        </span>
                        <a
                          href={projectDetails?.url?.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {projectDetails?.url?.name}
                        </a>
                      </li>
                    </ul>

                    {projectDetails?.features &&
                      projectDetails?.features.length > 0 && (
                        <>
                          <h4
                            className={
                              "text-4 font-weight-600 mt-4" +
                              (darkTheme ? " text-white" : "")
                            }
                          >
                            Key Features:
                          </h4>
                          <ul
                            className={
                              "list-style-2 " +
                              (darkTheme ? "list-style-light" : "")
                            }
                          >
                            {projectDetails.features.map((feature, index) => (
                              <li key={index}>{feature}</li>
                            ))}
                          </ul>
                        </>
                      )}

                    {projectDetails?.architecture && (
                      <>
                        <h4
                          className={
                            "text-4 font-weight-600 mt-4" +
                            (darkTheme ? " text-white" : "")
                          }
                        >
                          Architecture:
                        </h4>
                        <p>{projectDetails.architecture}</p>
                        {projectDetails.frontendStructure && (
                          <p>
                            <strong>Frontend:</strong>{" "}
                            {projectDetails.frontendStructure}
                          </p>
                        )}
                        {projectDetails.backendStructure && (
                          <p>
                            <strong>Backend:</strong>{" "}
                            {projectDetails.backendStructure}
                          </p>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectDetailsModal;
